<mat-form-field>
  <mat-label>{{ "Chooseadate" | translate }}</mat-label>
  <input
    [formControl]="dateControl"
    #dateInput
    matInput=""
    [min]="min"
    [max]="max"
    [matDatepicker]="picker"
    placeholder="{{ 'DateFormatPlaceholder' | translate }}"
    (dateChange)="change($event)"
    (input)="onDateInput($event)"
    (change)="onDateInput($event)"
    [attr.inputmode]="inputMode"
    [attr.autocomplete]="autocomplete"
  />
  <mat-datepicker-toggle
    matIconSuffix=""
    [for]="picker"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker startView="multi-year"></mat-datepicker>

  <mat-error>{{ "Checkdateinformed" | translate }}</mat-error>
</mat-form-field>
